import { atom } from "jotai";

/** 消息原子 */
export const initTracking = atom<any>(null);
